export const colors = {
  skin: {
    light: {
      base: '#fdd2b2',
      shadow: '#f3ab98',
    },
    yellow: {
      base: '#FBE8B3',
      shadow: '#EDD494',
    },
    brown: {
      base: '#D8985D',
      shadow: '#C6854E',
    },
    dark: {
      base: '#A56941',
      shadow: '#8D5638',
    },
    red: {
      base: '#CC734C',
      shadow: '#B56241',
    },
    black: {
      base: '#754437',
      shadow: '#6B3D34',
    },
  },
  hair: {
    blonde: {
      base: '#FEDC58',
      shadow: '#EDBF2E',
    },
    orange: {
      base: '#D96E27',
      shadow: '#C65C22',
    },
    black: {
      base: '#592d3d',
      shadow: '#592d3d',
    },
    white: {
      base: '#ffffff',
      shadow: '#E2E2E2',
    },
    brown: {
      base: '#A56941',
      shadow: '#8D5638',
    },
    blue: {
      base: '#85c5e5',
      shadow: '#67B7D6',
    },
    pink: {
      base: '#D69AC7',
      shadow: '#C683B4',
    },
  },
  lipColors: {
    red: {
      base: '#DD3E3E',
      shadow: '#C43333',
    },
    purple: {
      base: '#B256A1',
      shadow: '#9C4490',
    },
    pink: {
      base: '#D69AC7',
      shadow: '#C683B4',
    },
    turqoise: {
      base: '#5CCBF1',
      shadow: '#49B5CD',
    },
    green: {
      base: '#4AB749',
      shadow: '#3CA047',
    },
  },
  clothing: {
    white: {
      base: '#FFFFFF',
      shadow: '#E2E2E2',
    },
    blue: {
      base: '#85c5e5',
      shadow: '#67B7D6',
    },
    black: {
      base: '#633749',
      shadow: '#5E3244',
    },
    green: {
      base: '#89D86F',
      shadow: '#7DC462',
    },
    red: {
      base: '#D67070',
      shadow: '#C46565',
    },
  },
  bgColors: {
    blue: '#85c5e5',
    // green: '#89D86F',
    // red: '#ED9191',
  },
  outline: '#592d3d',
  white: '#ffffff',
  tongue: '#f28195',
}
